export default "__VITE_ASSET__BcOd5TuU__"